import MuiButton from '@mui/material/Button';
import type { ButtonProps } from './IButton';
import { styles } from './styles';

const Button = ({ sx, children, ...rest }: ButtonProps) => (
    <MuiButton
        sx={[styles.root, ...(Array.isArray(sx) ? sx : [sx])]}
        {...rest}
    >
        {children}
    </MuiButton>
);

export default Button;
